module.exports = __webpack_public_path__ + "img/x.806d9833.png";